import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SalonService } from '../service/salon.service';
import { SubdomainService } from '../service/subdomain.service';
import { SalonStore } from '../store/salon.store';
import { AppUrls } from '../../app-urls';

export const subdomainHomeGuard: CanActivateFn = async (): Promise<boolean> => {
  const router = inject(Router);
  const salonService = inject(SalonService);
  const subdomainService = inject(SubdomainService);
  const salonStore = inject(SalonStore);

  const slug = subdomainService.getSubdomain();
  if (!slug) {
    return true;
  }

  const salonId = salonStore.id() ?? (await salonService.getSalonIdBySlug(slug));
  if (!salonId) {
    return true;
  }

  await router.navigate(AppUrls.salon(salonId), { skipLocationChange: true });
  return false;
};
